function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { themeGet, space, fontSize } from 'styled-system';
import { applySizes, applyVariations, getPaletteColor, getTextColorOn, deprecatedColorValue, deprecatedPropType } from '../utils';
var sizes = {
  small: css(["", " line-height:", ";min-height:20px;& > svg{width:12px;height:12px;}"], themeGet('textStyles.small'), themeGet('lineHeights.display')),
  medium: css(["", " line-height:", ";min-height:24px;& > svg{width:14px;height:14px;}"], themeGet('textStyles.display0'), themeGet('lineHeights.standard'))
};
var variations = {
  outline: css(["color:", ";border-color:", ";", ""], getPaletteColor('base'), function (props) {
    return getPaletteColor(props.borderColor, 'base')(props);
  }, function (props) {
    return props.bg ? "background-color: ".concat(getPaletteColor(props.bg, 'base')(props), ";") : '';
  }),
  fill: css(["color:", ";background-color:", ";border-color:", ";"], getTextColorOn('base'), getPaletteColor('base'), getPaletteColor('base')),
  // todo: remove this copy of the fill variation in v4 as its name does not follow conventions
  solid: css(["color:", ";background-color:", ";border-color:", ";"], getTextColorOn('base'), getPaletteColor('base'), getPaletteColor('base'))
};
var Stamp = styled.div.withConfig({
  displayName: "Stamp",
  componentId: "ss5inb-0"
})(["display:inline-flex;align-items:center;vertical-align:top;min-height:24px;text-transform:uppercase;letter-spacing:", ";border-radius:2px;border-width:1px;border-style:solid;color:", ";", ";", ";", " ", ";"], themeGet('letterSpacings.caps'), getPaletteColor('base'), function (_ref) {
  var theme = _ref.theme;
  return applySizes(sizes, undefined, theme.mediaQueries);
}, applyVariations('Stamp', variations), space, fontSize);
Stamp.displayName = 'Stamp';
Stamp.propTypes = _objectSpread(_objectSpread(_objectSpread({}, space.propTypes), fontSize.propTypes), {}, {
  size: PropTypes.oneOfType([PropTypes.oneOf(Object.keys(sizes)), PropTypes.arrayOf(PropTypes.oneOf(Object.keys(sizes)))]),
  variation: PropTypes.oneOf(Object.keys(variations)),
  color: deprecatedColorValue(),
  bg: deprecatedPropType('color'),
  borderColor: deprecatedColorValue()
});
Stamp.defaultProps = {
  px: 1,
  py: 0,
  color: 'border.light',
  bg: 'background.light',
  borderColor: 'border.base',
  size: 'medium',
  variation: 'outline'
};
export default Stamp;